import React from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import Win1Icon from '../../../images/win_1.png'
import Win2Icon from '../../../images/win_2.png'
import Win3Icon from '../../../images/win_3.png'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 70,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 30,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 8,
    marginVertical: 1,
    lineHeight: 1.2,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  tableColHeader: {
    padding: 2,
    borderStyle: 'solid',
    borderWidth: 0.3,
    borderColor: '#000',
    justifyContent: 'center', // по вертикали
  },

  tableText: {
    fontSize: 8,
    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
  tieNote: {
    fontSize: 6,
    color: '#666',
    textAlign: 'center',
  },
})

const PairCountTournamentProtocolPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  totalFishCount,
  totalWeight,
  averageFishWeight,
  biggestFish,
  isfinish,
}) => {
  console.log('mainLogo', mainLogo)
  function formatWeight(weight) {
    return weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  return (
    <Document style={{ margin: 0 }} scale={0.9}>
      <Page
        size="A4"
        style={{
          paddingBottom: 30,
          paddingRight: 20,
          paddingLeft: 20,
          paddingTop: 20,
          fontFamily: 'Roboto',
        }}
      >
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              Водоём:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.water_body}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата проведения:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата составления:{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>

        <Text
          style={{
            fontSize: 12,

            textAlign: 'center',
            marginBottom: 10,
          }}
        >
          {isfinish
            ? 'ПРОТОКОЛ ПО КОЛИЧЕСТВУ ПОЙМАННОЙ РЫБЫ'
            : 'ИНФОРМАЦИОННЫЙ ПРОТОКОЛ ПО КОЛИЧЕСТВУ ПОЙМАННОЙ РЫБЫ'}
        </Text>
        {/* <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 10 }}>
          Ловля карпа – парные соревнования, код дисциплины 0920151811Л
        </Text> */}

        {/* Таблица результатов */}
        <View>
          <View
            style={{
              width: '100%',
              borderStyle: 'solid',
              borderWidth: 0.3,
              borderColor: '#000',
            }}
          >
            <View
              style={{
                height: '20px',
                flexDirection: 'row',
                alignItems: 'stretch', // важно!
              }}
            >
              <View style={[styles.tableColHeader, { width: '55%' }]}>
                <Text style={[styles.tableText, { textAlign: 'left' }]}>
                  {' '}
                  Команда
                </Text>
              </View>
              <View style={[styles.tableColHeader, { width: '15%' }]}>
                <Text style={styles.tableText}>Сектор</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '15%' }]}>
                <Text style={styles.tableText}> Кол-во рыбы</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '15%' }]}>
                <Text style={styles.tableText}> Быллы</Text>
              </View>

              {/* <Text style={[styles.tableColHeader, { width: '16%' }]}>
                Примечание
              </Text> */}
            </View>
          </View>

          {data.map((item, index) => (
            <View key={index} wrap={false}>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'stretch', // важно для одинаковой высоты 8FBC8F
                  backgroundColor:
                    item.overallRank < 4
                      ? '#fff'
                      : item.totalWeight === 0
                        ? '#fff'
                        : '#fff',
                }}
              >
                {/* Место с иконками для призеров */}
                <View
                  style={[
                    styles.tableColHeader,
                    { width: '55%', alignItems: 'flex-start' },
                  ]}
                >
                  <Text style={[styles.tableText, { textAlign: 'left' }]}>
                    <Text style={{ fontWeight: 'bold' }}>{item.teamName}</Text>
                    {'\n'}
                    {item.sp}
                  </Text>
                </View>

                <View style={[styles.tableColHeader, { width: '15%' }]}>
                  <Text style={styles.tableText}>
                    {formatWeight(item.sector)}
                  </Text>
                </View>
                <View style={[styles.tableColHeader, { width: '15%' }]}>
                  <Text style={styles.tableText}>
                    {formatWeight(
                      item.fishList.filter((f) => f.weight > 0).length
                    )}
                  </Text>
                </View>

                <View style={[styles.tableColHeader, { width: '15%' }]}>
                  <Text style={styles.tableText}>
                    {item.overallRank % 1 === 0
                      ? item.overallRank
                      : item.overallRank.toFixed(1)}
                  </Text>
                </View>

                {/* <Text
                  style={{ width: '16%', fontSize: 7, textAlign: 'center' }}
                >
                  {item.disqualified
                    ? 'Снята'
                    : item.isTie
                      ? 'Деление мест'
                      : ''}
                </Text> */}
              </View>
            </View>
          ))}
        </View>

        {/* Итоговые значения */}
        {/* <View style={{ marginTop: 10 }}>
          <Text style={{ fontSize: 8 }}>
            Всего зачётной рыбы: {totalFishCount} шт. / Общий вес: {totalWeight}{' '}
            г / Средний вес: {averageFishWeight} г
          </Text>
          <Text style={{ fontSize: 8 }}>
            Самая крупная рыба: {biggestFish.weight} г (Команда:{' '}
            {biggestFish.pair})
          </Text>
        </View> */}

        {/* Подписи */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 30,
          }}
        >
          {administrator.map((admin, i) => (
            <View
              key={i}
              style={{
                width: '45%',
                borderTop: '1px solid #000',
                paddingTop: 2,
              }}
            >
              <Text style={{ fontSize: 8, textAlign: 'center' }}>
                {admin.surname} {admin.name} {admin.patronymic} ({admin.role},{' '}
                {admin.rank})
              </Text>
            </View>
          ))}
        </View>

        {/* Логотипы спонсоров */}
        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default PairCountTournamentProtocolPDF
